export default "__VITE_ASSET__d9v$0A$P__"